import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
import { PREPOPULATE_INPUT } from "@/utils/prepopulate_input.js";
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";

export default {
    name: 'CIPCVerification',
    mixins: [MAIN_CONTROLLER, PREPOPULATE_INPUT],
    components: {
        BreadCrumb,
        ClientLogo
    },
    data: () => ({
        company_registration: '',
        reg1: '',
        reg2: '',
        reg3: '',
        company_name: ''
    }),

    computed: {
        workflow_id() {
            return this.$store.getters.get_workflow_id;
        }
    },
    watch: {
      company_registration(new_val) {
      // Assuming the appropriate length for validation is 14 (e.g. "1234/567890/12")
        if (new_val && new_val.length >= 12) {
            // Create a mock event to pass to validate_reg_number
            const event = {
            target: {
                value: new_val,
                selectionStart: new_val.length
            },
            key: ''
            };
            this.validate_reg_number(event);
        }
      }
    },
    methods: {
        validate_reg_number(event) {
            let input = event.target.value.replace(/\D/g, ''), position = event.target.selectionStart;
            if (event.key === 'Backspace' && position === 0) return;

            this.reg1 = input.slice(0, 4);
            this.reg2 = input.slice(4, 10);
            this.reg3 = input.slice(10);

            this.company_registration = [this.reg1, this.reg2, this.reg3].filter(Boolean).join('/').slice(0, 14);

            this.$nextTick(() => {
                let new_position = position + (this.company_registration.length - input.length);
                event.target.selectionStart = event.target.selectionEnd = new_position;
            });
        },
        save_cipc_info() {
            if (!this.company_registration.trim()) {
                $('.reg-message').removeClass('d-none');
                setTimeout(() => {
                    $('.reg-message').addClass('d-none');
                }, 3000);
                return false;
            }
            if (!this.company_name.trim()) {
                $('.company-name-message').removeClass('d-none');
                setTimeout(() => {
                    $('.company-name-message').addClass('d-none');
                }, 3000);
                return false;
            }
            const TOKEN = localStorage.getItem('token');
            const COMPANY_INFO_API = `${API_BASE_URL}/verify_api/compliance_verification/cipc/`;

            const FORM_DATA = {
                reg1: this.reg1,
                reg2: this.reg2,
                reg3: this.reg3,
                company_name: this.company_name,
                workflow_id: this.workflow_id,
                on_behalf_application: this.$route.name === 'behalf_application' ? true : false,
            };

            $.ajax({
                url: COMPANY_INFO_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify(FORM_DATA),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });
                },
                success: (response) => {
                    Swal.close();
                    if (response.status && response.status === "error") {
                        let message = response
                        $('.reg-message').text(message).removeClass('d-none');
                        setTimeout(() => {
                            $('.reg-message').text('').addClass('d-none');
                        }, 3000);
                    } else if (
                        response.status &&
                        response.status === "success" &&
                        response.result
                    ) {
                        this.completeService();
                    }  else if (response.status == "success" && response.message){
                        Swal.fire({
                            icon: 'success',
                            title: response.status,
                            text: response.message,
                            confirmButtonText: 'OK'
                        }).then(() => {
                            this.completeService();
                        });
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            text: "Our service is currently unavailable. Please contact your service provider and try again later",
                        })
                    }
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Error verifying company'

                    if (error.responseJSON) {
                        if (error.responseJSON.Error) {
                            error_message = error.responseJSON.Error;
                        } if (error.responseJSON.reg3) {
                            error_message = 'Please enter a valid company registration number';
                        } else {
                            error_message = error.responseJSON;
                        }
                        $('.error-message').text(error_message).removeClass('d-none');
                        setTimeout(() => {
                            $('.error-message').text('').addClass('d-none');
                        }, 3000);
                    } else {
                        $('.error-message').text(error_message).removeClass('d-none');
                        setTimeout(() => {
                            $('.error-message').text('').addClass('d-none');
                        }, 3000);
                    }
                }
            });
        }
    },

    mounted() {
        if (!validateToken(this.$router)) {
            return;
        }
        this.get_customer_data();
    }
};
